export const environment = {
  production: true,
  chatbotFeatureFlag: false,
  manualBlockTimeEntryFeatureFlag: true,
  layerSettings: {
    'boundary': { 
      filterByExtent: false 
    },
    'roads': { 
      minScale: 30000,
      filterByExtent: true,
      popup: {
        includeFields: ['RoadId', 'Name', 'MaintOwner', 'CollectionAllowed']
      }
    }
  } as Record<string, { minScale?: number; filterByExtent?: boolean; popup?: { includeFields?: string[]; excludeFields?: string[] } }>,
  esri: {
    apiKey: 'AAPKfb21386f7ec0403f91e79c8ea0216881KYN7Sz3khZf2zspAxq8Hho06gYI_ZIxSHw3rlRGHyv-fapE73eb-uVHbigZa5riZ',
  },
  appShellConfig: {
    debug: false,
    networkDelay: 500,
  },
  applicationInsightsConnectionString: 'InstrumentationKey=36e0873e-c397-4944-87f5-50aead5f2eee;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=c68c97f1-b504-4da7-bfa6-879f09cee125',
  legacyApiUrl: 'https://api.recoverytrac.com',
  authApiUrl: 'https://api.recoverytrac.com/auth/api',
  activityApiUrl: 'https://api.recoverytrac.com/activity/api',
  auditApiUrl: 'https://api.recoverytrac.com/audit/api',
  projectApiUrl: 'https://api.recoverytrac.com/project/api',
  userApiUrl: 'https://api.recoverytrac.com/user/api',
  lookupApiUrl: 'https://api.recoverytrac.com/lookup/api',
  timeRecordApiUrl: 'https://api.recoverytrac.com/timerecord/api',
  timeApiUrl: 'https://api.recoverytrac.com/time/api',
  mobileApiUrl: 'https://api.recoverytrac.com/mobile/api',
  attachmentApiUrl: 'https://api.recoverytrac.com/attachment/api',
  rolesApiUrl: 'https://api.recoverytrac.com/role/api',
  flexFormsApiUrl: 'https://api.recoverytrac.com/form/api',
  notificationApiUrl: 'https://api.recoverytrac.com/notification/api',
  webApiBaseUrl: 'https://api.recoverytrac.com/api',
  authApiKey: 'eEy1WT6vVV5PVlCVUc0wFhSnFuHfhDt8',
  apimSubscriptionKey: 'ffa0a619be0b45edb8152c3a4b0930fa',
  fakeGPS: {
    useFakeGPS: false,
    latitude: 40.714224,
    longitude: -73.961452,
  },
  version: '4.10.4',
  pollingTimeMs: 300000,
  sharedFormQrCodeEncryptionKey: 'YDKGM',
  receiptQrCodeEncryptionKey: 'EJQDXPIU',
  defaultLoggingLevel: 1, // ERROR
};
